import { createContext, useContext, useState, ReactNode } from "react";

interface PaysFiltreContextValue {
  paysIds: number[];
  togglePaysId: (id: number) => void;
  clearPaysIds: () => void;
}

const PaysFiltreContext = createContext<PaysFiltreContextValue | undefined>(undefined);

export function PaysFiltreProvider({ children }: { children: ReactNode }) {
  const [paysIds, setPaysIds] = useState<number[]>([]);

  const togglePaysId = (id: number) => {
    setPaysIds((current) =>
      current.includes(id) ? current.filter((p) => p !== id) : [...current, id]
    );
  };

  const clearPaysIds = () => setPaysIds([]);

  return (
    <PaysFiltreContext.Provider value={{ paysIds, togglePaysId, clearPaysIds }}>
      {children}
    </PaysFiltreContext.Provider>
  );
}

export function usePaysFiltre() {
  const ctx = useContext(PaysFiltreContext);
  if (!ctx) throw new Error("usePaysFiltre must be used within PaysFiltreProvider");
  return ctx;
}
